import { render, staticRenderFns } from "./noheader.vue?vue&type=template&id=32cb1eb0&scoped=true"
import script from "./noheader.vue?vue&type=script&lang=js"
export * from "./noheader.vue?vue&type=script&lang=js"
import style0 from "./noheader.vue?vue&type=style&index=0&id=32cb1eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb1eb0",
  null
  
)

export default component.exports